<template>
    <div class="navigation-bullets d-none d-lg-block">
        <div v-if="links.length > 1">
            <scrollactive :offset="220" :duration="100" class="my-nav">
                <a
                    v-for="navigationLink in links"
                    :key="navigationLink.link"
                    :href="'#' + navigationLink.link"
                    class="navigation-bullets_anchor scrollactive-item"
                >
                    <span class="navigation-bullets_bullet"></span>
                    <span class="navigation-bullets__label">
                        {{ navigationLink.name }}
                    </span>
                </a>
            </scrollactive>
        </div>
        <div v-else class="spinner">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NavigationBullets',
    data() {
        return {
            links: []
        };
    },

    mounted() {
        Object.keys(this.$root.$refs).forEach(key => {
            let thisId = this.$root.$refs[key].id;

            if (typeof thisId === 'undefined') {
                thisId = this.$root.$refs[key].$el.id;
            }

            if (typeof thisId !== 'undefined') {
                const linkObject = { name: key, link: thisId };
                this.links.push(linkObject);
            }
        });
    }
};
</script>

<style lang="scss" scoped>
.navigation-bullets {
    position: fixed;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 150;
}

.navigation-bullets_anchor {
    display: block;
    position: relative;

    &:not(:last-of-type) {
        margin-bottom: 0.9375rem;
    }

    &.is-active {
        .navigation-bullets_bullet {
            background-color: $color-blue;
        }
    }
}

.navigation-bullets_bullet {
    width: 1rem;
    height: 1rem;
    display: block;
    background-color: white;
    border: 3px solid $color-blue;
    border-radius: 50%;

    &:hover {
        background-color: $color-blue;
        transition: 0.5s;
    }

    &:hover + .navigation-bullets__label {
        pointer-events: all;
        opacity: 1;
        transition: opacity 0.5s ease-in-out;
    }
}

.navigation-bullets__label {
    position: absolute;
    right: 80px;
    text-align: right;
    opacity: 0;
    padding: 0 1rem;
    top: -9px;
    color: $color-black;
    font-size: 1.25rem;
    font-weight: $font-weight-light;
    background-color: $color-white;
    border-radius: 16px;
    pointer-events: none;
    white-space: nowrap;

    &:after {
        position: absolute;
        right: -50px;
        content: '';
        border-bottom: 2px solid $color-black;
        width: 3rem;
        padding-top: 1rem;
    }
}
</style>
